import React from 'react';
import { Helmet } from 'react-helmet';
import soledad from '../assets/images/soledadcanyon.jpg';
import palosverdes from '../assets/images/palosverdeslighthouse.jpg';

const AboutMe = () => {
    return (
        <div className="innerDiv clearfix">
            <Helmet>
                <title>Rafsan Bari - Experience as a web developer</title>
                <meta name="description" content="My experience as a web developer" />
            </Helmet>
            <div class="pagetitle"><h1>About Me</h1></div>
            <h3>Where It All Started</h3>
            <p>
                Since I was a kid, I've always been curious about how things worked. I used to take things apart just to see their inner workings. 
                The same thought struck me the first time I used the internet: 'How does this website know to show me the 'About' page when I click that link?' 
                I wanted to take it apart and truly understand it.
            </p>
            <p>
                In high school, I got that chance. I learned to build basic web pages using tables—though I might have gone a little overboard with the animated GIFs! 
                Armed with this new knowledge, I was eager to create my own web page at home but couldn't think of a subject. 
                Then, an idea struck: I took screenshots of my favorite video game at the time, <i>Metal Gear Solid</i>, added text, and created an HTML storyboard. 
                Over time, I kept adding more screenshots and text to the page and made it longer and longer. Before I knew it, I had a webpage that was 15 miles long.
            </p>
            <p>
                Later, an internship gave me the invaluable opportunity to work alongside a seasoned web developer, building real world websites for real world companies. 
                I picked up a wealth of knowledge and tricks from him, which truly opened my world to the vast possibilities of development. As I discovered, if you can dream it, you can make it.
            </p>
            <h3>Beyond The Resume</h3>
            <p>  
                Away from the keyboard, my passion lies in driving and discovering the best driving roads. There is a sense of freedom in setting out early, while the world is still asleep. 
                The sky is still dark, the air is crisp and a profound quiet envelopes everything--- that is, until I make my way through. Running through the gears, 
                getting the rev-matching just right for the perfect shift brings a deep sense of reward and feeling at one with the machine. 
            </p>
            <img src={soledad} alt="Soledad Canyon" class="article-image image-left"/><br/><br/>
            <p>
               And sometimes a particular stretch of asphalt perfectly embodies this feeling. Soledad Canyon Road comes to mind as one of the great roads I've experienced. 
               It's practically deserted early in the morning and is a beautiful example of the desert and mountains merging. 
               Driving through the winding roads, watching the sun rise as I head towards Santa Clarita was so much fun. And getting to an early morning breakfast spot for a 
               nice cup of coffee just ties the entire experience together.
            </p>
            <div className="clearfix"></div>
            <img src={palosverdes} alt="Point Vicente Lighthouse" class="article-image image-right"/><br/><br/>
            <p>   
                As if the desert wasn't scenic enough, my pursuit of the best roads led me to Palos Verdes Drive, a short but picturesque stretch. The gently winding road follows the oceanfront
                but not in a Santa Monica beach kind of way. It was on that drive that I stumbled upon the Point Vicente Lighthouse. Tucked away like a secret, it instantly felt 
                like a scene straight from a postcard. 
            </p>
            <div className="clearfix"></div>
            <p>
                Ultimately, whether I am crafting code or navigating a winding road, I am driven by the desire for precision, discovery and the satisfaction of mastering a challenge. 
            </p>

        </div>
    )
}

export default AboutMe;